/* ARGOING Desert Storm REV18 · Blocco 3 · «Il mio veicolo»
   Ricerca guidata a 5 passi (Marca → Modello → Versione → Motorizzazione → Anno), chip in testata,
   salvataggio in localStorage (chiave ag_veicolo), badge di compatibilità (agFit).
   Espone: window.agVeicolo = { get(), set(v), open(step), close(), clear(), fit(card), aggiorna() }
   Evento: document «ag:veicolo» (detail = veicolo salvato oppure null). */
(function () {
  'use strict';
  var KEY = 'ag_veicolo';
  var root = document.querySelector('[data-ag-veicolo]');
  var panel = document.querySelector('[data-ag-v-panel]');
  var SRC = root ? root.getAttribute('data-src') : null;
  var PAGINA = (root && root.getAttribute('data-pagina')) || '/pages/ricerca-per-veicolo';
  var WA = (root && root.getAttribute('data-wa')) || '393351813665';
  var ANNO_OGGI = new Date().getFullYear();
  var D = null, caricamento = null, ultimoFocus = null;

  /* ---------- normalizzazione grafie (regole R1-R2 del censimento) ---------- */
  var ALIAS_MARCHE = { 'land-rover': 'land rover', 'landrover': 'land rover', 'kgm': 'kgm ssangyong', 'kgm-ssangyong': 'kgm ssangyong', 'ssangyong': 'kgm ssangyong', 'ssang yong': 'kgm ssangyong', 'mercedes': 'mercedes-benz', 'mercedes benz': 'mercedes-benz', 'vw': 'volkswagen', 'great wall': 'gwm', 'gwm great wall': 'gwm', 'dodge': 'ram', 'galloper': 'hyundai', 'citroen': 'citroën', 'skoda': 'škoda', 'holden': 'chevrolet' };
  var ALIAS_MODELLI = { 'l200 triton': 'l200', 'triton / l200': 'l200', 'l200 / triton': 'l200', 'triton': 'l200', 'np300 navara d23': 'navara', 'navara np300 d23': 'navara', 'np300': 'navara', 'navara d40': 'navara', 'navara d22': 'navara', 'clase x': 'classe x', 'hilux gr sport ii': 'hilux', 'hilux revo': 'hilux', 'hilux vigo': 'hilux', 'ram 1500': '1500', 'ram 1500 classic': '1500', 'silverado 1500': 'silverado', 'sierra 1500': 'sierra', 'landcruiser j150': 'land cruiser', 'land cruiser j79': 'land cruiser', 'landcruiser': 'land cruiser', 'l cruiser': 'land cruiser', 'montero': 'pajero', 'montero v60': 'pajero', 'super exceed': 'galloper', 'exceed': 'galloper', 'musso sports': 'musso', 'musso grand': 'musso', 'musso ev': 'musso', 'grand musso': 'musso', 'd-max/rodeo': 'd-max', 'rodeo': 'd-max', 'dmax': 'd-max', 'lx 450/470/570': 'lx', 'transit custom / tourneo custom': 'transit custom', 'tourneo custom': 'transit custom', 'vito/clase v w447': 'vito', 'classe v': 'vito', 'ranger-raptor': 'ranger raptor', 'f. ranger': 'ranger' };
  function low(s) { return String(s || '').trim().toLowerCase().replace(/\s+/g, ' '); }
  function nMarca(s) { var k = low(s); if (D && D.alias_marche && D.alias_marche[k]) return low(D.alias_marche[k]); return ALIAS_MARCHE[k] || k; }
  function nModello(s) { var k = low(s); if (D && D.alias_modelli && D.alias_modelli[k]) return low(D.alias_modelli[k]); return ALIAS_MODELLI[k] || k; }
  function lista(v) {
    /* i metafield lista arrivano come array; a volte un elemento è a sua volta una stringa JSON (doppia codifica) */
    var out = [];
    function add(x) {
      if (x == null) return;
      if (Array.isArray(x)) { x.forEach(add); return; }
      var s = String(x).trim();
      if (!s) return;
      if (s.charAt(0) === '[') { try { add(JSON.parse(s)); return; } catch (e) { } }
      s.split(';').forEach(function (p) { p = p.trim(); if (p) out.push(p); });
    }
    add(v);
    return out;
  }
  function tokens(s) {
    return low(s).replace(/[^a-z0-9àèéìòù\.]+/g, ' ').split(' ').filter(function (t) { return t.length >= 2 && !/^(19|20)\d\d$/.test(t) && ['ford', 'toyota', 'serie', 'restyling', 'base', 'doppia', 'cabina', 'cab', 'double', 'extra', 'super', 'single', 'king', 'crew', 'dc', 'ec', 'sc', 'nuovo', 'nuova', 'prado', 'gemello'].indexOf(t) < 0; });
  }
  function anniIn(s) {
    var m = String(s || '').match(/((?:19|20)\d\d)\s*(?:[-–>+]|→|a|al)?\s*((?:19|20)\d\d)?/);
    if (!m) return null;
    var a = parseInt(m[1], 10), b = m[2] ? parseInt(m[2], 10) : (/[>+→]|oggi|dal/i.test(s) ? ANNO_OGGI : a);
    return [a, b];
  }

  /* ---------- stato salvato ---------- */
  function get() { try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && v.marca ? v : null; } catch (e) { return null; } }
  function salva(v) {
    try { if (v) localStorage.setItem(KEY, JSON.stringify(v)); else localStorage.removeItem(KEY); } catch (e) { }
    aggiornaChip(); applicaBadge();
    try { document.dispatchEvent(new CustomEvent('ag:veicolo', { detail: v })); } catch (e) { }
  }
  function etichetta(v) {
    if (!v) return '';
    var a = [v.marca, v.modello]; if (v.versione) a.push(v.versione);
    var s = a.join(' '); if (v.motore) s += ' · ' + v.motore; if (v.anno) s += ' · ' + v.anno;
    return s;
  }
  function aggiornaChip() {
    var v = get();
    document.querySelectorAll('[data-ag-v-chip]').forEach(function (c) {
      var l = c.querySelector('[data-ag-v-lbl]');
      c.classList.toggle('is-empty', !v);
      if (l) l.textContent = v ? (v.label || etichetta(v)) : 'Scegli il tuo veicolo';
      c.setAttribute('aria-label', v ? 'Il mio veicolo: ' + (v.label || etichetta(v)) + '. Cambia' : 'Scegli il tuo veicolo');
    });
  }

  /* ---------- compatibilità lato client ---------- */
  function agFit(card) {
    var v = get();
    if (!v) return 'none';
    if (!card) return 'verifica';
    var make = lista(card.make), model = lista(card.model), gen = lista(card.gen);
    var univ = !!card.universale || make.concat(model).some(function (x) { return /^universal/i.test(x); });
    if (univ) return 'universale';
    var yf = card.year_from ? parseInt(card.year_from, 10) : null, yt = card.year_to ? parseInt(card.year_to, 10) : null;
    if (!make.length && !model.length) return 'verifica';
    var vm = nMarca(v.marca), vmo = nModello(v.modello);
    var okMarca = !make.length || make.some(function (m) { return nMarca(m) === vm; });
    if (!okMarca) return 'no';
    if (!model.length) return 'verifica';
    var okModello = model.some(function (m) {
      var nm = nModello(m);
      if (nm === vmo) return true;
      /* «Land Cruiser J79», «Hilux Revo»: il nome del modello scelto sta dentro la grafia del prodotto */
      return (' ' + nm + ' ').indexOf(' ' + vmo + ' ') >= 0 || (' ' + vmo + ' ').indexOf(' ' + nm + ' ') >= 0;
    });
    if (!okModello) return 'no';
    var anno = v.anno ? parseInt(v.anno, 10) : null;
    var genOk = false, genDati = gen.length > 0, genAnni = false;
    if (genDati) {
      var tv = tokens((v.generazione_codice || '') + ' ' + (v.generazione || ''));
      gen.forEach(function (g) {
        var tg = tokens(g);
        if (tv.length && tg.some(function (t) { return tv.indexOf(t) >= 0; })) genOk = true;
        var r = anniIn(g); if (r && anno) { genAnni = true; if (anno >= r[0] && anno <= r[1]) genOk = true; }
      });
    }
    if (genOk) return 'ok';
    if (anno && (yf || yt)) { if (anno >= (yf || 0) && anno <= (yt || ANNO_OGGI)) return 'ok'; return 'no'; }
    if (genDati && (genAnni || tokens(gen.join(' ')).length)) return 'no';
    return 'verifica';
  }
  var ICONE = {
    ok: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    universale: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M4 12h16M12 4c3 3 3 13 0 16M12 4c-3 3-3 13 0 16"/></svg>',
    verifica: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 8v5M12 16h.01"/></svg>',
    no: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    none: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 15V9l3-4h8l4 4h3v6"/><circle cx="7.5" cy="17" r="2"/><circle cx="17.5" cy="17" r="2"/></svg>'
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function applicaBadge(scope) {
    var v = get(), lbl = v ? esc([v.marca, v.modello, v.versione].filter(Boolean).join(' ')) : '';
    (scope || document).querySelectorAll('.ag-fit[data-ag-fit]').forEach(function (el) {
      var card = null; try { card = JSON.parse(el.getAttribute('data-ag-fit') || '{}'); } catch (e) { }
      var s = agFit(card), scheda = el.classList.contains('ag-fit--scheda');
      el.className = el.className.replace(/\bag-fit--(ok|universale|verifica|no|none)\b/g, '').replace(/\s+/g, ' ').trim() + ' ag-fit--' + s;
      el.setAttribute('data-ag-fit-stato', s);
      var t, tb;
      if (s === 'ok') { t = 'Compatibile con il tuo ' + lbl; tb = 'Compatibile'; }
      else if (s === 'universale') { t = 'Universale'; tb = 'Universale'; }
      else if (s === 'verifica') { t = 'Da verificare con noi'; tb = 'Da verificare'; }
      else if (s === 'no') { t = 'Non compatibile con il tuo ' + lbl; tb = 'Non compatibile'; }
      else { t = '<a href="' + esc(PAGINA) + '" data-ag-veicolo-open>Scegli il tuo veicolo</a> per vedere la compatibilità'; tb = '<a href="' + esc(PAGINA) + '" data-ag-veicolo-open>Scegli il veicolo</a>'; }
      var x = (scheda && s !== 'none') ? '<button type="button" class="ag-fit__x" data-ag-veicolo-open>cambia</button>' : '';
      /* su telefono la card mostra solo icona + parola breve (regola mobile 4 del concept) */
      el.innerHTML = ICONE[s] + '<span class="ag-fit__l">' + t + '</span>' + (scheda ? '' : '<span class="ag-fit__s">' + tb + '</span>') + x;
      el.title = el.querySelector('.ag-fit__l').textContent;
    });
  }

  /* ---------- dati ---------- */
  function carica() {
    if (D) return Promise.resolve(D);
    if (caricamento) return caricamento;
    if (!SRC) return Promise.reject(new Error('manca data-src'));
    caricamento = fetch(SRC, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { D = j; return D; }).catch(function (e) { caricamento = null; throw e; });
    return caricamento;
  }
  function marcaDi(nome) { return D.marche.filter(function (m) { return m.nome === nome; })[0] || null; }
  function modelloDi(M, nome) { return M ? (M.modelli.filter(function (m) { return m.nome === nome; })[0] || null) : null; }
  function uniq(a) { var o = []; a.forEach(function (x) { if (x && o.indexOf(x) < 0) o.push(x); }); return o; }
  function annoA(g) { return g.anno_a || ANNO_OGGI; }
  function spanAnni(gs) {
    var a = Math.min.apply(null, gs.map(function (g) { return g.anno_da || ANNO_OGGI; }));
    var b = Math.max.apply(null, gs.map(annoA));
    return a + (b >= ANNO_OGGI ? ' → oggi' : '-' + b);
  }
  function gensFiltrate(MO, versione, motore) {
    var gs = MO.generazioni;
    if (versione) { var gv = gs.filter(function (g) { return g.versioni.indexOf(versione) >= 0; }); if (gv.length) gs = gv; }
    if (motore) { var gm = gs.filter(function (g) { return g.motori.indexOf(motore) >= 0 || g.motori_trovati.indexOf(motore) >= 0; }); if (gm.length) gs = gm; }
    return gs;
  }
  function generazionePer(MO, versione, motore, anno) {
    var gs = gensFiltrate(MO, versione, motore).filter(function (g) { return anno >= (g.anno_da || 0) && anno <= annoA(g); });
    if (!gs.length) gs = MO.generazioni.filter(function (g) { return anno >= (g.anno_da || 0) && anno <= annoA(g); });
    if (!gs.length) return { gen: null, ambigua: [] };
    gs.sort(function (a, b) { return (b.anno_da || 0) - (a.anno_da || 0); });
    return { gen: gs[0], ambigua: gs.slice(1) };
  }

  /* ---------- silhouette (segnaposto foto quando foto è null) ---------- */
  function sil(tipo) {
    var t = low(tipo);
    if (/van|commerciale/.test(t)) return '<svg viewBox="0 0 96 46" aria-hidden="true"><path d="M6 34h84M8 34V14h50l14 6 14 2v12"/><path d="M58 14v8h26M14 14v-2h40"/><circle cx="24" cy="35" r="5.5"/><circle cx="72" cy="35" r="5.5"/></svg>';
    if (/fuoristrada|suv/.test(t)) return '<svg viewBox="0 0 96 46" aria-hidden="true"><path d="M6 34h84M10 34V20l8-10h44l10 10h18v14"/><path d="M18 20h58M40 10v10M62 10v10"/><circle cx="24" cy="35" r="5.5"/><circle cx="72" cy="35" r="5.5"/></svg>';
    return '<svg viewBox="0 0 96 46" aria-hidden="true"><path d="M6 34h84M10 34V20l10-10h26l14 10h26v14"/><path d="M60 20H20M86 20v-4H60"/><circle cx="24" cy="35" r="5.5"/><circle cx="72" cy="35" r="5.5"/></svg>';
  }
  function foto(g, tipo, cls) {
    return '<span class="ag-v-ph ' + (cls || '') + '">' + (g && g.foto ? '<img src="' + esc(g.foto) + '" alt="" loading="lazy">' : sil(tipo)) + '</span>';
  }

  /* ---------- pannello ---------- */
  var S = { step: 1, marca: null, modello: null, versione: null, motore: null, anno: null, filtro: '' };
  var el = panel ? {
    body: panel.querySelector('[data-ag-v-body]'), h: panel.querySelector('[data-ag-v-h]'), sub: panel.querySelector('[data-ag-v-sub]'),
    steps: panel.querySelectorAll('[data-ag-v-goto]'), prog: panel.querySelector('[data-ag-v-prog]'),
    back: panel.querySelector('[data-ag-v-back]'), close: panel.querySelector('[data-ag-v-close]'),
    foot: panel.querySelector('[data-ag-v-foot]'), footS: panel.querySelector('[data-ag-v-foot-s]'), next: panel.querySelector('[data-ag-v-next]')
  } : null;
  var NOMI = ['', 'MARCA', 'MODELLO', 'VERSIONE', 'MOTORIZZAZIONE', 'ANNO'];
  var NONSO_V = 'Non so / tutte le versioni', NONSO_M = 'Non so / tutte le motorizzazioni';

  function valore(k) {
    if (k === 1) return S.marca; if (k === 2) return S.modello;
    if (k === 3) return S.versione === null ? null : (S.versione || NONSO_V);
    if (k === 4) return S.motore === null ? null : (S.motore || NONSO_M);
    if (k === 5) return S.anno; return null;
  }
  function open(step) {
    if (!panel) { location.href = PAGINA; return; }
    ultimoFocus = document.activeElement;
    var v = get();
    if (v && !S.marca) { S.marca = v.marca; S.modello = v.modello; S.versione = v.versione || ''; S.motore = v.motore || ''; S.anno = v.anno || null; }
    S.step = step || (S.anno ? 6 : 1);
    panel.hidden = false; document.documentElement.classList.add('ag-v-aperto'); document.body.style.overflow = 'hidden';
    render();
    carica().then(render).catch(function () {
      el.body.innerHTML = '<p class="ag-v-msg">Non riesco a caricare l’elenco dei veicoli. <a href="' + esc(PAGINA) + '">Vai alla pagina Cerca per veicolo</a></p>';
    });
  }
  function close() {
    if (!panel) return;
    panel.hidden = true; document.documentElement.classList.remove('ag-v-aperto'); document.body.style.overflow = '';
    if (ultimoFocus && ultimoFocus.focus) { try { ultimoFocus.focus(); } catch (e) { } }
  }
  function vai(step) { S.step = step; render(); panel.scrollTop = 0; }
  function scegli(k, val) {
    if (k === 1 && val !== S.marca) { S.marca = val; S.modello = null; S.versione = null; S.motore = null; S.anno = null; }
    else if (k === 2 && val !== S.modello) { S.modello = val; S.versione = null; S.motore = null; S.anno = null; }
    else if (k === 3) { S.versione = val; }
    else if (k === 4) { S.motore = val; }
    else if (k === 5) { S.anno = val; }
    S.filtro = '';
    var prossimo = k + 1;
    /* se il passo successivo è già compilato si torna al riepilogo (si stava cambiando una voce) */
    if (k < 5 && valore(prossimo) !== null && S.anno) prossimo = 6;
    vai(prossimo);
  }
  function corrente() {
    if (!D || !S.marca || !S.modello || !S.anno) return null;
    var M = marcaDi(S.marca), MO = modelloDi(M, S.modello); if (!MO) return null;
    var r = generazionePer(MO, S.versione, S.motore, parseInt(S.anno, 10)), g = r.gen;
    var handle = (g && g.collezione_handle) || MO.collezione_handle || M.collezione_handle || null;
    var v = {
      marca: S.marca, modello: S.modello, versione: S.versione || '', motore: S.motore || '', anno: parseInt(S.anno, 10),
      generazione_id: g ? g.id : null, generazione: g ? g.nome : '', generazione_codice: g ? g.codice : '',
      generazione_ambigua: r.ambigua.map(function (x) { return x.id; }),
      cabina: (g && g.cabine && g.cabine.length === 1) ? g.cabine[0] : null,
      tipo: MO.tipo || '', collezione_handle: handle, prodotti_oggi: g ? g.prodotti_oggi !== false : true,
      url: handle ? ('/collections/' + handle + '?ag_v=' + encodeURIComponent(g ? g.id : MO.id)) : (PAGINA + '?ag_v=' + encodeURIComponent(MO.id)),
      salvato: new Date().toISOString().slice(0, 10)
    };
    v.label = etichetta(v);
    return v;
  }
  function salvaCorrente(chiudi) { var v = corrente(); if (v) salva(v); if (chiudi) close(); return v; }
  function waLink(v) {
    var t = 'Buongiorno, vi scrivo dal sito argoingshop.it/pages/ricerca-per-veicolo\n\nIl mio veicolo: ' + [v.marca, v.modello, v.versione].filter(Boolean).join(' ') +
      (v.motore ? ', ' + v.motore : '') + ', anno ' + v.anno + (v.generazione ? ' (generazione ' + v.generazione + (v.generazione_codice && v.generazione_codice !== v.generazione ? ' ' + v.generazione_codice : '') + ')' : '') +
      '.\nNon è esattamente quello che trovo nella ricerca guidata: potete aiutarmi a scegliere gli accessori giusti?';
    return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(t);
  }

  function render() {
    if (!el) return;
    var k = S.step, v;
    /* schede dei passi */
    el.steps.forEach(function (b, i) {
      var n = i + 1, val = valore(n), vv = b.querySelector('.ag-v-step__v');
      var done = val !== null && n !== k;
      b.classList.toggle('is-done', done); b.classList.toggle('is-cur', n === k); b.classList.toggle('is-off', !done && n !== k);
      vv.textContent = n === k && k <= 5 ? 'Scegli…' : (val !== null ? val : '—');
      b.disabled = !done;
    });
    if (el.prog) { el.prog.querySelector('.ag-v-prog__t').textContent = k <= 5 ? 'PASSO ' + k + ' DI 5 · ' + NOMI[k] : 'RIEPILOGO'; el.prog.querySelector('i').style.width = (Math.min(k, 5) / 5 * 100) + '%'; }
    el.back.hidden = k <= 1;
    el.foot.hidden = false;
    if (!D) { el.body.innerHTML = '<p class="ag-v-msg">Carico l’elenco dei veicoli…</p>'; el.next.disabled = true; el.footS.textContent = ''; return; }
    var M = marcaDi(S.marca), MO = modelloDi(M, S.modello), h = '';
    if (k === 1) {
      el.h.textContent = 'Di che marca è il tuo veicolo?';
      el.sub.textContent = 'Scegli la marca: poi ti chiediamo modello versione motorizzazione e anno di immatricolazione.';
      h += '<label class="ag-v-cerca"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg><input type="search" placeholder="Cerca la marca…" value="' + esc(S.filtro) + '" data-ag-v-filtro autocomplete="off" aria-label="Cerca la marca"></label>';
      var f = low(S.filtro);
      if (!f && D.popolari && D.popolari.length) {
        h += '<p class="ag-v-k">Più cercate</p><div class="ag-v-grid ag-v-grid--6">';
        D.popolari.forEach(function (n) { var m = marcaDi(n); if (!m) return; h += tileMarca(m, true); });
        h += '</div>';
      }
      h += '<p class="ag-v-k">' + (f ? 'Risultati' : 'Tutte le marche') + '</p><div class="ag-v-grid ag-v-grid--4">';
      var tot = 0;
      D.marche.forEach(function (m) { if (f && low(m.nome).indexOf(f) < 0) return; tot++; h += tileMarca(m, false); });
      if (!tot) h += '<p class="ag-v-none">Nessuna marca con questo nome. <a href="' + esc(waLink({ marca: S.filtro, modello: '', versione: '', anno: '?' })) + '" target="_blank" rel="noopener">Scrivici su WhatsApp</a> e la aggiungiamo.</p>';
      h += '</div>';
    } else if (k === 2) {
      el.h.textContent = 'Quale ' + S.marca + ' hai?';
      el.sub.textContent = 'Scegli il modello. Le versioni speciali che cambiano gli accessori (ad esempio Ranger Raptor) sono elencate come modello a sé.';
      h += '<div class="ag-v-grid">';
      (M ? M.modelli : []).forEach(function (mo) {
        var gs = mo.generazioni, g0 = gs[gs.length - 1];
        h += '<button type="button" class="ag-v-tile' + (mo.nome === S.modello ? ' is-on' : '') + '" data-ag-v-pick="2" data-v="' + esc(mo.nome) + '">' + foto(g0, mo.tipo, '') +
          '<span class="ag-v-tile__tx"><span class="ag-v-tile__t">' + esc(mo.nome) + '</span><span class="ag-v-tile__m">' + esc(spanAnni(gs)) + '</span><span class="ag-v-tile__s">' + esc(mo.tipo || '') + (gs.length > 1 ? ' · ' + gs.length + ' generazioni' : '') + '</span></span></button>';
      });
      h += '</div><p class="ag-v-none">Non trovi il tuo modello? <a href="' + esc(waLink({ marca: S.marca, modello: S.filtro, versione: '', anno: '?' })) + '" target="_blank" rel="noopener">Scrivici su WhatsApp</a>: ti rispondiamo noi.</p>';
    } else if (k === 3) {
      el.h.textContent = 'Quale versione di ' + S.modello + ' hai?';
      var vers = uniq([].concat.apply([], (MO ? MO.generazioni : []).map(function (g) { return g.versioni; })));
      el.sub.textContent = vers.length ? 'La versione (allestimento) è scritta sul portellone e sul libretto. Se non la conosci scegli «Non so»: ti mostriamo comunque tutto.' : 'Per questo modello non distinguiamo ancora le versioni: vai avanti con «Non so / tutte le versioni».';
      h += '<div class="ag-v-grid">';
      vers.forEach(function (x) {
        var gs = MO.generazioni.filter(function (g) { return g.versioni.indexOf(x) >= 0; });
        h += '<button type="button" class="ag-v-tile' + (S.versione === x ? ' is-on' : '') + '" data-ag-v-pick="3" data-v="' + esc(x) + '"><span class="ag-v-tile__tx"><span class="ag-v-tile__t">' + esc(x) + '</span><span class="ag-v-tile__m">' + esc(spanAnni(gs)) + '</span></span></button>';
      });
      h += '<button type="button" class="ag-v-tile ag-v-tile--alt' + (S.versione === '' ? ' is-on' : '') + '" data-ag-v-pick="3" data-v=""><span class="ag-v-tile__tx"><span class="ag-v-tile__t">' + NONSO_V + '</span><span class="ag-v-tile__s">Va bene lo stesso: la compatibilità si verifica su generazione e anno</span></span></button></div>';
    } else if (k === 4) {
      el.h.textContent = 'Che motorizzazione ha il tuo ' + S.modello + '?';
      var gsv = MO ? gensFiltrate(MO, S.versione, null) : [];
      var mot = uniq([].concat.apply([], gsv.map(function (g) { return g.motori; })));
      el.sub.textContent = mot.length ? 'La cilindrata è sul libretto (voce P.1 o P.5). Se non la conosci scegli «Non so»: il motore serve solo per sospensioni snorkel e protezioni.' : 'Per questo modello non abbiamo ancora l’elenco delle motorizzazioni: vai avanti con «Non so / tutte le motorizzazioni».';
      h += '<div class="ag-v-grid">';
      mot.forEach(function (x) {
        var gs = gsv.filter(function (g) { return g.motori.indexOf(x) >= 0; });
        h += '<button type="button" class="ag-v-tile' + (S.motore === x ? ' is-on' : '') + '" data-ag-v-pick="4" data-v="' + esc(x) + '"><span class="ag-v-tile__tx"><span class="ag-v-tile__t">' + esc(x) + '</span><span class="ag-v-tile__m">' + esc(spanAnni(gs)) + '</span></span></button>';
      });
      h += '<button type="button" class="ag-v-tile ag-v-tile--alt' + (S.motore === '' ? ' is-on' : '') + '" data-ag-v-pick="4" data-v=""><span class="ag-v-tile__tx"><span class="ag-v-tile__t">' + NONSO_M + '</span><span class="ag-v-tile__s">Va bene lo stesso per hard top cassettiere e protezioni</span></span></button></div>';
    } else if (k === 5) {
      el.h.textContent = 'Di che anno è il tuo ' + S.modello + '?';
      el.sub.textContent = 'Anno di prima immatricolazione (sul libretto, voce B). Dalla combinazione versione motore e anno ricaviamo la generazione esatta.';
      var gs5 = MO ? gensFiltrate(MO, S.versione, S.motore) : [], a0 = Math.min.apply(null, gs5.map(function (g) { return g.anno_da || ANNO_OGGI; })), a1 = Math.max.apply(null, gs5.map(function (g) { return annoA(g); }));
      if (!isFinite(a0)) a0 = ANNO_OGGI - 30;
      if (!isFinite(a1) || a1 > ANNO_OGGI) a1 = ANNO_OGGI;
      h += '<div class="ag-v-grid ag-v-grid--6">';
      for (var y = a0; y <= a1; y++) h += '<button type="button" class="ag-v-tile ag-v-tile--y' + (String(S.anno) === String(y) ? ' is-on' : '') + '" data-ag-v-pick="5" data-v="' + y + '"><span class="ag-v-tile__t">' + y + '</span></button>';
      h += '</div>';
    } else {
      v = corrente();
      el.h.textContent = 'Abbiamo capito questo veicolo';
      el.sub.textContent = 'Controlla le voci: puoi cambiarne una con un tocco. Poi vedi i prodotti compatibili o salva il veicolo per ritrovarlo in tutto il negozio.';
      if (v) {
        var gtxt = v.generazione ? ('Generazione ' + v.generazione + (v.generazione_codice && v.generazione_codice !== v.generazione ? ' · ' + v.generazione_codice : '') + (v.cabina ? ' · ' + v.cabina : '')) : 'Generazione non determinata dall’anno indicato';
        h += '<div class="ag-v-sum"><p class="ag-v-sum__h">' + esc(v.label) + '</p><p class="ag-v-sum__g">' + esc(gtxt) + (v.generazione_ambigua.length ? ' · anno a cavallo di due generazioni: verifichiamo noi' : '') + '</p><div class="ag-v-sum__row">' +
          voce(1, 'Marca', v.marca) + voce(2, 'Modello', v.modello) + voce(3, 'Versione', v.versione || NONSO_V) + voce(4, 'Motore', v.motore || NONSO_M) + voce(5, 'Anno', v.anno) + '</div>' +
          (v.prodotti_oggi ? '' : '<p class="ag-v-sum__np">Per questa generazione non abbiamo ancora prodotti a catalogo: scrivici e ti diciamo cosa possiamo procurare.</p>') +
          '<div class="ag-v-sum__act"><a class="ag-v-btn ag-v-btn--p" href="' + esc(v.url) + '" data-ag-v-vedi>Vedi i prodotti compatibili</a><button type="button" class="ag-v-btn ag-v-btn--o" data-ag-v-salva>Salva come mio veicolo</button>' +
          '<p class="ag-v-sum__wa">Non è esattamente il tuo?<br><a href="' + esc(waLink(v)) + '" target="_blank" rel="noopener">Scrivici su WhatsApp</a>, rispondiamo noi.</p></div>' +
          (get() ? '<button type="button" class="ag-v-sum__rm" data-ag-v-rimuovi>Rimuovi il veicolo salvato</button>' : '') + '</div>';
      } else h += '<p class="ag-v-msg">Manca qualche dato: torna ai passi precedenti.</p>';
    }
    el.body.innerHTML = h;
    /* piede telefono */
    if (k <= 5) { var val = valore(k); el.next.textContent = 'Continua'; el.next.disabled = val === null; el.footS.textContent = val !== null ? NOMI[k].charAt(0) + NOMI[k].slice(1).toLowerCase() + ': ' + val : 'Scegli una voce'; }
    else { el.next.textContent = 'Vedi i prodotti compatibili'; el.next.disabled = !v; el.footS.textContent = v ? v.label : ''; }
    var inp = el.body.querySelector('[data-ag-v-filtro]'); if (inp && S.filtro) { inp.focus(); try { inp.setSelectionRange(inp.value.length, inp.value.length); } catch (e) { } }
  }
  function tileMarca(m, pop) {
    var ini = esc(m.nome.replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase() || '?');
    var logo = m.logo ? '<img src="' + esc(m.logo) + '" alt="" loading="lazy">' : ini;
    return '<button type="button" class="ag-v-tile ag-v-tile--c' + (m.nome === S.marca ? ' is-on' : '') + '" data-ag-v-pick="1" data-v="' + esc(m.nome) + '">' + (pop ? '<span class="ag-v-logo">' + logo + '</span>' : '') + '<span class="ag-v-tile__tx"><span class="ag-v-tile__t">' + esc(m.nome) + '</span></span></button>';
  }
  function voce(k, nome, val) { return '<button type="button" data-ag-v-goto="' + k + '"><small>' + nome + '</small> ' + esc(val) + ' <u>cambia</u></button>'; }

  /* ---------- eventi ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    var ap = t.closest('[data-ag-veicolo-open]');
    if (ap) { if (panel) { e.preventDefault(); open(ap.getAttribute('data-ag-veicolo-step') ? parseInt(ap.getAttribute('data-ag-veicolo-step'), 10) : 0); } return; }
    /* link di menu «Cerca per veicolo»: si intercetta solo se il JSON è già caricato, altrimenti si va alla pagina */
    var a = t.closest('a[href]');
    if (a && panel && D && !a.closest('[data-ag-v-panel]')) {
      var hr = a.getAttribute('href') || '';
      if (hr.indexOf(PAGINA) >= 0 || /\/pages\/(ricerca|cerca)-per-veicolo/.test(hr)) { e.preventDefault(); open(0); return; }
    }
    if (!panel || panel.hidden || !panel.contains(t)) return;
    var p = t.closest('[data-ag-v-pick]'); if (p) { scegli(parseInt(p.getAttribute('data-ag-v-pick'), 10), p.getAttribute('data-v')); return; }
    var g = t.closest('[data-ag-v-goto]'); if (g && !g.disabled) { vai(parseInt(g.getAttribute('data-ag-v-goto'), 10)); return; }
    if (t.closest('[data-ag-v-back]')) { vai(Math.max(1, Math.min(S.step - 1, 5))); return; }
    if (t.closest('[data-ag-v-close]')) { close(); return; }
    if (t.closest('[data-ag-v-salva]')) { salvaCorrente(true); return; }
    if (t.closest('[data-ag-v-vedi]')) { salvaCorrente(false); return; }
    if (t.closest('[data-ag-v-rimuovi]')) { clear(); close(); return; }
    if (t.closest('[data-ag-v-next]')) {
      if (S.step <= 5) { if (valore(S.step) !== null) vai(S.step === 5 ? 6 : S.step + 1); }
      else { var vv = salvaCorrente(false); if (vv) location.href = vv.url; }
      return;
    }
    if (e.target === panel) close();
  });
  document.addEventListener('input', function (e) {
    var i = e.target && e.target.getAttribute && e.target.hasAttribute('data-ag-v-filtro') ? e.target : null;
    if (!i) return; S.filtro = i.value; render();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel && !panel.hidden) close(); });
  /* precarica il JSON al passaggio sul chip o sul link di menu, così il clic non aspetta */
  document.addEventListener('mouseover', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-ag-veicolo-open],a[href*="per-veicolo"]') : null;
    if (t) carica().catch(function () { });
  }, { passive: true });
  /* badge inseriti dopo (filtri Empire, caricamenti successivi) */
  if (window.MutationObserver) {
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && (n.matches('.ag-fit[data-ag-fit]') || n.querySelector('.ag-fit[data-ag-fit]'))) applicaBadge(n.parentNode || n); }); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function set(v) { if (!v || !v.marca || !v.modello) return; v.label = v.label || etichetta(v); salva(v); }
  function clear() { S = { step: 1, marca: null, modello: null, versione: null, motore: null, anno: null, filtro: '' }; salva(null); }
  window.agFit = agFit;
  window.agVeicolo = { get: get, set: set, open: open, close: close, clear: clear, fit: agFit, aggiorna: function () { aggiornaChip(); applicaBadge(); }, dati: function () { return carica(); } };
  aggiornaChip(); applicaBadge();
  /* ?ag_v=<id> in una collezione: se il veicolo salvato non c'è, si segnala solo (il filtro vero arriva con il fitment) */
  document.dispatchEvent(new CustomEvent('ag:veicolo-pronto', { detail: get() }));
})();
